/* API */
const Login = '/api/auth/jwt/login'
const SignUp = '/api/auth/register'
// const BaseInfo = '/api/v1/admin/user/base/info'
// const UserList = '/api/v1/admin/user'
// const Info = '/api/v1/admin/user/info'
const AllData = '/api/pension/get_pension_result/'
const SupportCities = '/api/pension/support_cities'
export default {
  Login,
  SignUp,
  // BaseInfo,
  // UserList,
  // Info,
  AllData,
  SupportCities
}



// WEBPACK FOOTER //
// ./src/api/api.js